export default {
  columns: {
    title: 'Title',
    image: 'Image',
    button_url: 'Button Url',
    button_text: 'Button Text',
    description: 'Description',
    visible: 'Visible',
    actions: 'Actions',
  },
  buttons: {
    create_post: 'Create Post',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
  },
  title: 'Featured posts',
  delete_confirmation: 'Are you sure you want to delete this post?',
};
